(() => {
  const CART_ENABLED = true;
  const PRICE_TIERS = Object.freeze([4990, 5490, 5990, 6490, 6990, 7490, 7990, 8190]);
  const PRICE_ANCHORS = Object.freeze([3500, 4200, 5250, 6084, 6375]);
  const PRICE_BASES = Object.freeze([4490, 4490, 4490, 5190, 5390]);
  const PRICE_VARIANTS = window.KK_WAF_PRICE_VARIANTS || Object.freeze({});
  const ARROW_KEYS = Object.freeze(['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp']);
  const roundHalfUp = (value, divisor) => Math.floor((value + divisor / 2) / divisor);
  const exactPriceCents = (width, depth) => {
    const area = Math.round(Number(width) * Number(depth));
    if (area <= PRICE_ANCHORS[0]) return PRICE_BASES[0] + 500;
    const last = PRICE_ANCHORS.length - 1;
    if (area >= PRICE_ANCHORS[last]) return roundHalfUp(area * PRICE_BASES[last], PRICE_ANCHORS[last]) + 500;
    const index = PRICE_ANCHORS.findIndex((anchor, i) => area >= anchor && area <= PRICE_ANCHORS[i + 1]);
    const span = PRICE_ANCHORS[index + 1] - PRICE_ANCHORS[index];
    return PRICE_BASES[index] + roundHalfUp((area - PRICE_ANCHORS[index]) * (PRICE_BASES[index + 1] - PRICE_BASES[index]), span) + 500;
  };
  const getTier = (exactCents) => {
    const index = PRICE_TIERS.findIndex((tier) => tier >= exactCents);
    const tierIndex = index < 0 ? PRICE_TIERS.length - 1 : index;
    return { id: `P${String(tierIndex + 1).padStart(2, '0')}`, priceCents: PRICE_TIERS[tierIndex] };
  };
  const money = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const getVariant = (design, tier) => {
    if (!design?.stoffcode || !tier?.id) return null;
    const targetSku = `${design.stoffcode}112-SM-${tier.id}`;
    const mapped = PRICE_VARIANTS[targetSku];
    if (!mapped || mapped.priceCents !== tier.priceCents || !/^gid:\/\/shopify\/ProductVariant\/\d+$/.test(mapped.variantId)) return null;
    return { targetSku, variantId: mapped.variantId, priceCents: mapped.priceCents };
  };
  const numericVariantId = (variantId) => {
    const numericId = String(variantId || '').split('/').pop();
    return /^\d+$/.test(numericId) ? numericId : null;
  };

  document.querySelectorAll('[data-kk-waf-root]').forEach((root) => {
    const cards = [...root.querySelectorAll('[data-kk-waf-card]')];
    const fabricTypes = [...root.querySelectorAll('[data-kk-waf-fabric-type]')];
    const fabricGroups = [...root.querySelectorAll('[data-kk-waf-fabric-group]')];
    const swatches = [...root.querySelectorAll('[data-kk-waf-swatch]')];
    const width = root.querySelector('[data-kk-waf-width]');
    const depth = root.querySelector('[data-kk-waf-depth]');
    const widthOutput = root.querySelector('[data-kk-waf-width-output]');
    const depthOutput = root.querySelector('[data-kk-waf-depth-output]');
    const price = root.querySelector('[data-kk-waf-price]');
    const selectedDesign = root.querySelector('[data-kk-waf-selected-design-label], .kk-waf__selected-design-label');
    const propertiesOutput = root.querySelector('[data-kk-waf-properties]');
    const customApply = root.querySelector('[data-kk-waf-custom-apply]');
    const addToCart = root.querySelector('[data-kk-waf-add-to-cart]');
    const selectionValue = root.querySelector('[data-kk-waf-selection-value]');
    const status = root.querySelector('[data-kk-waf-status]');
    const customCard = root.querySelector('[data-kk-waf-custom-card]');
    const continueButton = root.querySelector('[data-kk-waf-continue]');
    const outerPath = root.querySelector('[data-kk-waf-svg-outer]');
    const innerPath = root.querySelector('[data-kk-waf-svg-inner]');
    const widthLine = root.querySelector('[data-kk-waf-svg-width-line]');
    const depthLine = root.querySelector('[data-kk-waf-svg-depth-line]');
    const widthLabel = root.querySelector('[data-kk-waf-svg-width-label]');
    const depthLabel = root.querySelector('[data-kk-waf-svg-depth-label]');
    if (!cards.length || !width || !depth) return;

    const skuPattern = root.dataset.kkWafSkuPattern || '{STOFFCODE}112-SM';
    let activeFabricKey = '';
    let design = null;
    let cartBusy = false;
    let selection = { type: 'standard', id: cards[0].dataset.cardId, label: cards[0].dataset.sizeLabel || '50 × 70 cm', url: cards[0].dataset.resultUrl || '' };
    const customLabel = () => `${width.value} × ${depth.value} cm`;
    const setStatus = (message) => { if (status) status.textContent = message; };
    const refreshConfiguredCart = async () => {
      if (typeof window.refreshCart === 'function') {
        // The Borders theme refreshes helper-cart, header totals and opens the drawer here.
        // Older theme builds do not return the underlying fetch promise, so give that
        // refresh a short async turn before announcing success.
        const refreshResult = window.refreshCart(true);
        if (refreshResult && typeof refreshResult.then === 'function') await refreshResult;
        else await new Promise((resolve) => window.setTimeout(resolve, 250));
        return;
      }

      // Safe fallback for a page where component-cart.js has not exposed refreshCart yet.
      const response = await fetch('?section_id=helper-cart', { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Cart refresh failed');
      const text = await response.text();
      if (typeof window.renderHelperCart !== 'function') throw new Error('Cart renderer unavailable');
      window.renderHelperCart(text);
      const drawer = document.querySelector('[data-js-site-cart-sidebar]');
      if (drawer && typeof drawer.show === 'function') drawer.show();
    };
    const syncState = (tier = null, variant = null) => {
      root.dataset.kkWafSelectionType = selection.type;
      root.dataset.kkWafSelectionLabel = selection.label || '';
      root.dataset.kkWafSelectionDesign = design?.label || '';
      root.dataset.kkWafSelectionStoffcode = design?.stoffcode || '';
      root.dataset.kkWafSelectionPriceTier = tier?.id || '';
      root.dataset.kkWafSelectionTierPriceCents = variant?.priceCents ? String(variant.priceCents) : '';
      root.dataset.kkWafSelectionTargetSku = variant?.targetSku || '';
      root.dataset.priceTier = tier?.id || '';
      root.dataset.tierPriceCents = variant?.priceCents ? String(variant.priceCents) : '';
      root.dataset.design = design?.label || '';
      root.dataset.stoffcode = design?.stoffcode || '';
      root.dataset.targetSku = variant?.targetSku || '';
      root.dataset.kkWafSelectionSkuReference = design?.skuReference || skuPattern.replace('{STOFFCODE}', design?.stoffcode || '');
      root.dataset.kkWafSelectionProductId = design?.productId || '';
      root.dataset.kkWafSelectionProductHandle = design?.productHandle || '';
      root.dataset.kkWafSelectionSourceVariantId = design?.sourceVariantId || '';
      root.dataset.kkWafSelectionSourceVariantSku = design?.sourceVariantSku || '';
      root.dataset.kkWafSelectionTargetVariantId = variant?.variantId || '';
      if (selectedDesign) selectedDesign.textContent = design?.label || 'Bitte Stoffart und Design auswählen';
      if (propertiesOutput) propertiesOutput.textContent = design?.facts || 'Stoffeigenschaften werden nach der Auswahl eingeblendet.';
    };
    const updateCartButton = (variant) => {
      if (!addToCart) return;
      addToCart.disabled = cartBusy || !CART_ENABLED || !variant;
      addToCart.setAttribute('aria-disabled', String(addToCart.disabled));
      addToCart.setAttribute('aria-busy', String(cartBusy));
    };
    const updatePrice = () => {
      const tier = getTier(exactPriceCents(width.value, depth.value));
      const variant = design ? getVariant(design, tier) : null;
      if (price) price.textContent = variant ? `Gesamtpreis: ${money(variant.priceCents)}` : 'Bitte Stoffdesign auswählen';
      updateCartButton(selection.type === 'custom' ? variant : null);
      syncState(design ? tier : null, selection.type === 'custom' ? variant : null);
      return { tier, variant };
    };
    const resetDesignDisplay = () => {
      if (selectedDesign) selectedDesign.textContent = 'Bitte Stoffart und Design auswählen';
      if (propertiesOutput) propertiesOutput.textContent = 'Stoffeigenschaften werden nach der Auswahl eingeblendet.';
    };
    const setFabricType = (button) => {
      activeFabricKey = button.dataset.fabricKey || '';
      setStatus('');
      fabricTypes.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      fabricGroups.forEach((group) => {
        const visible = group.dataset.fabricKey === activeFabricKey;
        group.hidden = !visible;
        group.querySelectorAll('[data-kk-waf-swatch]').forEach((item) => { item.tabIndex = -1; });
      });
      const group = fabricGroups.find((item) => item.dataset.fabricKey === activeFabricKey);
      group?.querySelector('[data-kk-waf-swatch]')?.setAttribute('tabindex', '0');
      design = null;
      swatches.forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-checked', 'false'); });
      resetDesignDisplay();
      setSelection({ type: 'standard', id: cards[0].dataset.cardId, label: cards[0].dataset.sizeLabel || '50 × 70 cm', url: cards[0].dataset.resultUrl || '' });
    };
    const updateGraphic = () => {
      const w = Number(width.value), d = Number(depth.value);
      const left = 42 - ((w - 45) / 55) * 18, right = 158 + ((w - 45) / 55) * 18;
      const top = 20, bottom = 120 + ((d - 60) / 30) * 20, innerLeft = left + 18, innerRight = right - 18;
      outerPath?.setAttribute('d', `M ${left + 3} ${top} C ${left + 1} ${top}, ${left} ${top + 2}, ${left} ${top + 5} L ${left} ${bottom - 5} C ${left} ${bottom - 2}, ${left + 2} ${bottom}, ${left + 5} ${bottom} L ${right - 5} ${bottom} C ${right - 2} ${bottom}, ${right} ${bottom - 2}, ${right} ${bottom - 5} L ${right} ${top + 5} C ${right} ${top + 2}, ${right - 1} ${top}, ${right - 3} ${top} Z`);
      innerPath?.setAttribute('d', `M ${innerLeft} 39 L ${innerLeft} ${bottom - 10} M ${innerLeft} 39 L ${innerRight} 39 L ${innerRight} ${bottom - 10}`);
      widthLine?.setAttribute('d', `M ${left} ${bottom + 8} L ${right} ${bottom + 8}`);
      depthLine?.setAttribute('d', `M ${left - 10} ${top} L ${left - 10} ${bottom}`);
      if (widthLabel) { widthLabel.textContent = `${w} cm`; widthLabel.setAttribute('x', `${(left + right) / 2}`); widthLabel.setAttribute('y', `${bottom + 17}`); }
      if (depthLabel) { depthLabel.textContent = `${d} cm`; depthLabel.setAttribute('y', `${(top + bottom) / 2}`); depthLabel.setAttribute('transform', `rotate(-90 ${left - 17} ${(top + bottom) / 2})`); }
      if (widthOutput) widthOutput.textContent = `${w} cm`;
      if (depthOutput) depthOutput.textContent = `${d} cm`;
    };
    const setDesign = (swatch) => {
      design = { label: swatch.dataset.designLabel || '', stoffcode: swatch.dataset.stoffcode || '', productId: swatch.dataset.productId || '', productHandle: swatch.dataset.productHandle || '', sourceVariantId: swatch.dataset.sourceVariantId || '', sourceVariantSku: swatch.dataset.sourceVariantSku || '', sourceVariantImage: swatch.dataset.sourceVariantImage || '', skuReference: swatch.dataset.skuReference || '', facts: swatch.dataset.stoffeigenschaften || '' };
      setStatus('');
      swatches.forEach((item) => { const selected = item === swatch; item.classList.toggle('is-selected', selected); item.setAttribute('aria-checked', String(selected)); item.tabIndex = selected ? 0 : -1; });
      if (selectedDesign) selectedDesign.textContent = design.label;
      if (propertiesOutput) propertiesOutput.textContent = design.facts || 'Für dieses Design sind aktuell keine zusätzlichen Stoffeigenschaften hinterlegt.';
      updatePrice();
      if (selection.type === 'custom') { selection.label = `${customLabel()} · ${design.label}`; if (selectionValue) selectionValue.textContent = selection.label; }
    };
    const setSelection = (next) => {
      selection = next;
      cards.forEach((card) => { const selected = selection.type === 'standard' && card.dataset.cardId === selection.id; card.classList.toggle('is-selected', selected); card.setAttribute('aria-pressed', String(selected)); });
      if (customCard) customCard.dataset.selected = String(selection.type === 'custom');
      if (customApply) customApply.setAttribute('aria-pressed', String(selection.type === 'custom'));
      if (selectionValue) selectionValue.textContent = selection.label;
      updatePrice();
    };
    const selectStandard = (card) => {
      design = null;
      setStatus('');
      activeFabricKey = '';
      fabricTypes.forEach((item) => { item.setAttribute('aria-selected', 'false'); item.classList.remove('is-selected'); item.tabIndex = 0; });
      fabricGroups.forEach((group) => { group.hidden = true; });
      swatches.forEach((item) => { item.setAttribute('aria-checked', 'false'); item.classList.remove('is-selected'); item.tabIndex = -1; });
      resetDesignDisplay();
      setSelection({ type: 'standard', id: card.dataset.cardId, label: card.dataset.sizeLabel, url: card.dataset.resultUrl });
    };
    const addConfiguredItem = async () => {
      if (cartBusy || !CART_ENABLED) return;
      const { tier, variant } = updatePrice();
      const variantId = numericVariantId(variant?.variantId);
      if (!design || !variant || !variantId || !tier) { setStatus('Die Auswahl konnte nicht sicher geprüft werden.'); return; }
      cartBusy = true;
      updateCartButton(variant);
      root.setAttribute('aria-busy', 'true');
      setStatus('Wird in den Warenkorb gelegt …');
      const properties = {
        Breite: `${width.value} cm`,
        Tiefe: `${depth.value} cm`,
        Maß: customLabel(),
        Stoffdesign: design.label,
        _kk_stoffbild: design.sourceVariantImage,
        _kk_schema: root.dataset.kkWafSchema || 'wickelauflage-sondermass-v1',
        _kk_stoffcode: design.stoffcode,
        _kk_preisstufe: tier.id,
        _kk_sku_referenz: design.skuReference || `${design.stoffcode}112-SM`,
        _kk_source_product: design.productId || design.productHandle || ''
      };
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload?.description || payload?.message || 'Cart add failed');
        await refreshConfiguredCart();
        setStatus('Deine Sondermaß-Wickelauflage wurde in den Warenkorb gelegt.');
      } catch (error) {
        setStatus('Die Wickelauflage konnte nicht hinzugefügt werden. Bitte versuche es erneut.');
        root.dataset.kkWafCartError = error?.message || 'unknown';
      } finally {
        cartBusy = false;
        root.setAttribute('aria-busy', 'false');
        updateCartButton(variant);
      }
    };
    cards.forEach((card) => card.addEventListener('click', () => selectStandard(card)));
    fabricTypes.forEach((button) => button.addEventListener('click', () => setFabricType(button)));
    fabricTypes.forEach((button) => button.addEventListener('keydown', (event) => {
      if (!ARROW_KEYS.includes(event.key)) return;
      event.preventDefault();
      const index = fabricTypes.indexOf(button);
      const step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      const next = fabricTypes[(index + step + fabricTypes.length) % fabricTypes.length];
      if (next) { setFabricType(next); next.focus(); }
    }));
    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => setDesign(swatch));
      swatch.addEventListener('keydown', (event) => {
        if (!ARROW_KEYS.includes(event.key)) return;
        event.preventDefault();
        const visible = swatches.filter((item) => item.closest('[data-kk-waf-fabric-group]')?.hidden === false);
        const index = visible.indexOf(swatch), step = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
        const next = visible[(index + step + visible.length) % visible.length];
        if (next) { setDesign(next); next.focus(); }
      });
    });
    [width, depth].forEach((input) => input.addEventListener('input', () => { updateGraphic(); updatePrice(); if (selection.type === 'custom') { selection.label = `${customLabel()} · ${design?.label || ''}`; if (selectionValue) selectionValue.textContent = selection.label; } }));
    customApply?.addEventListener('click', () => { if (!design) { setStatus('Bitte Stoffdesign auswählen.'); return; } setSelection({ type: 'custom', label: `${customLabel()} · ${design.label}`, url: '' }); setStatus('Deine Maß- und Designauswahl ist übernommen.'); });
    addToCart?.addEventListener('click', addConfiguredItem);
    if (continueButton) continueButton.addEventListener('click', () => { if (selection.type === 'custom') { setStatus('Deine Maß- und Designauswahl ist übernommen.'); return; } if (selection.url) window.location.assign(selection.url); });
    fabricGroups.forEach((group) => { group.hidden = true; });
    resetDesignDisplay();
    updateGraphic();
    if (fabricTypes[0]) setFabricType(fabricTypes[0]);
    else setSelection(selection);
  });
})();

